/*
 * Hallowroot cart bundle upsell.
 * Handles the "Add" buttons rendered by snippets/hr-cart-bundle-upsell.liquid:
 *  - Alderwood Soap Rest (completes the Alder & Suds bundle, $3 off)
 *  - free Lip Seal (with the Picnic Sparkler coozie)
 * Adds via the AJAX cart API, then dispatches the theme's native CartAddEvent so the
 * cart drawer / cart page re-render (and the upsell recomputes + disappears). Delegated
 * listener on document so it survives section re-renders. Added 2026-06-26.
 */
import { CartAddEvent } from '@theme/events';

function cartSectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
  });
  return ids;
}

async function addVariant(variantId, btn) {
  if (!variantId) return;
  const url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  btn.disabled = true;
  btn.classList.add('is-loading');
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'text/html' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: cartSectionIds().join(',') }),
    });
    const data = await response.json();
    if (data.status) {
      // error (e.g. out of stock) — re-enable and bail
      btn.disabled = false;
      btn.classList.remove('is-loading');
      return;
    }
    document.dispatchEvent(
      new CartAddEvent({}, 'hr-cart-upsell', { itemCount: 1, sections: data.sections })
    );
  } catch (err) {
    console.error('[hr-cart-upsell] add failed', err);
    window.location.reload();
  }
}

document.addEventListener('click', (event) => {
  const btn = event.target.closest('.hr-upsell__add');
  if (!btn) return;
  event.preventDefault();

  let variantId = btn.dataset.variant;

  // Lip Seal card: resolve the variant from the style + flavor selectors.
  const lipseal = btn.closest('[data-hr-lipseal]');
  if (lipseal) {
    const style = lipseal.querySelector('[data-hr-style]');
    const flavor = lipseal.querySelector('[data-hr-flavor]');
    let map = {};
    try {
      map = JSON.parse(lipseal.dataset.variantMap || '{}');
    } catch (e) {
      map = {};
    }
    variantId = map[`${style && style.value}|${flavor && flavor.value}`];
  }

  addVariant(variantId, btn);
});
